var path = '/modules/rsvps/components/al-rsvp-checkins/component.tpl.html';
var html = "<listview store=\"vm.store\"></listview>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/rsvps/components/al-rsvp-checkins/component.tpl.html
// module id = 2150
// module chunks = 1